/**
 * product-recommendations.js
 *
 * El tema traía el marcado <product-recommendations> en la ficha, pero este asset no
 * existía: el custom element nunca se definía, así que el elemento se quedaba vacío y
 * NINGUNA ficha del sitio mostraba "También te puede interesar" (verificado 2026-08-27:
 * el endpoint /recommendations/products sí devolvía 6 productos).
 *
 * Carga diferida: la petición solo sale cuando el bloque se acerca al viewport, para no
 * competir con el render de la ficha.
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          // Sin recomendaciones, el bloque se retira del todo en vez de dejar un hueco
          // con el encabezado colgando.
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          } else {
            this.remove();
            return;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(error => {
          console.error('product-recommendations:', error);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
